.div {
  position: relative;
  font-size: 14px;
  border: 1px solid var(--color-easil-gray-x-light);
  border-radius: 4px;
  line-height: 20px;
  color: var(--color-easil-black);
  min-height: 80px;
  width: 100%;
  padding: 10px 12px 10px 12px;
}

.textAreaDiv {
  width: 100%;
  max-height: 46px;
  background-color: #f5f5f8;
  border-radius: 4px;
  margin-right: 0;
  border: none;
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
  box-sizing: border-box;
  resize: none;
  transition: max-height 0.2s ease-in-out;
}

.textAreaDiv[data-isfocussed="true"] {
  max-height: 45vh !important;
}

.textAreaDiv[data-hasinputerror="true"] {
  display: flex;
  justify-content: center;
  align-items: center;
}

.errorWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.div[data-disabled="true"] {
  background-color: var(--color-background-disabled);
  cursor: not-allowed;
}

.div textarea[disabled] {
  background-color: var(--color-background-disabled);
  color: var(--color-font-disabled);
  cursor: not-allowed;
}

.div textarea {
  padding: 0px;
  color: var(--color-easil-black);
  width: 100%;
  border: none;
  vertical-align: top;
  resize: none;
}

.div textarea:focus {
  outline: none;
}

.div[data-error="true"] {
  border: 1px solid var(--color-easil-red);
}

.label {
  color: var(--color-easil-black);
  font-size: 13px;
  line-height: 1.85;
  text-align: left;
  padding-bottom: 9px;
}

.error {
  position: absolute;
  color: var(--color-easil-red);
  font-size: 12px;
  top: 100%;
  left: 5px;
}

.alertToolTip {
  font-size: 12px;
  width: 226px;
}
